import { Modal, theme } from "antd";
import React from "react";
import useIsMobile from "../../../../hooks/useIsMobile";
import "./compactModal.css";

export const NURSE_IP_COMPACT_MODAL_WRAP = "nurse-ip-compact-modal-wrap";

const { useToken } = theme;

const ClosePopup = ({
  open,
  setOpen,
  setVisible,
  removeUrlParams,
  setActiveTab,
  initialRefresh,
  mobileWrapClassName = NURSE_IP_COMPACT_MODAL_WRAP,
}) => {
  const isMobile = useIsMobile();
  const { token } = useToken();

  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      title="Discard changes"
      centered={isMobile}
      wrapClassName={isMobile ? mobileWrapClassName : undefined}
      getContainer={() => document.body}
      width={isMobile ? "min(400px, calc(100vw - 32px))" : undefined}
      okButtonProps={{
        style: {
          backgroundColor: token.colorPrimary,
          borderColor: token.colorPrimary,
        },
      }}
      onOk={() => {
        removeUrlParams && removeUrlParams();
        setVisible(false);
        setOpen(false);
        setActiveTab("1");
        initialRefresh && initialRefresh();
      }}
    >
      Are you sure to discard changes?
    </Modal>
  );
};

export default ClosePopup;
